// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"styles_breadcrumbs__8NiHn","header":"styles_header__JV206","header__content":"styles_header__content__4_hIH"};